import type { EntityType } from "@/lib/brokerAccounts";
import type { AuthedRequester } from "@/lib/brokerAuth";

// The People step's Title guidance (PMS-S813, BRK-S391): for each legal
// entity, the titles to offer an owner or officer, in order. Guidance, never
// a refusal: the chosen title goes to PMS as text (`title`), which stores
// any. An entity with no list (joint venture) asks the title as text.

export interface OwnerTitles {
  entityType: EntityType;
  /** Plain titles, in the order to offer them. */
  titles: string[];
}

/** GET /api/broker/owner-titles: every legal entity with its titles. */
export function getOwnerTitles(
  request: AuthedRequester,
): Promise<{ items: OwnerTitles[] }> {
  return request<{ items: OwnerTitles[] }>("/api/broker/owner-titles");
}

/** The titles to offer for a legal entity; none for one without a list, or
 *  none chosen yet, so the title is typed. */
export function titlesFor(
  items: readonly OwnerTitles[],
  entityType: EntityType | "",
): string[] {
  return items.find((i) => i.entityType === entityType)?.titles ?? [];
}
